export default __webpack_public_path__ + "static/media/thumb_circle.86301b50.webp";